import { useOrgPlanningScenarioStore } from '../stores/orgPlanningScenarioStore';
import { useAtlasDraftSaveRecoveryStore } from '../stores/atlasDraftSaveRecoveryStore';
import { useAtlasChangesStore } from '../stores/atlasChangesStore';

/** Rollback never feeds an existing protected draft into the legacy Yjs writer.
 * The shared review/recovery owner remains available to finish that work.
 */
export function atlasDraftRequiresProtectedAuthoring(diagramId: string | null | undefined): boolean {
  if (!diagramId) return false;
  return Boolean(useOrgPlanningScenarioStore.getState().selectedByDiagram[diagramId])
    || Object.values(useAtlasDraftSaveRecoveryStore.getState().attempts).some((attempt) => attempt.scope.diagramId === diagramId)
    || Object.values(useAtlasChangesStore.getState().interactions).some((interaction) =>
      interaction?.scope.diagramId === diagramId && !interaction.settled);
}
